export type { GetReturn, PathParam } from './isomorphic';
export { default } from './isomorphic';
